const BITWELD_POSTER_1 = "https://customer-assets-m6fa6gv7.emergentagent.net/job_maine-web/artifacts/dil17usu_WhatsApp%20Image%202026-06-27%20at%203.32.29%20PM%20%282%29.jpeg";
const BITWELD_POSTER_2 = "https://customer-assets-m6fa6gv7.emergentagent.net/job_maine-web/artifacts/2njo2sp6_WhatsApp%20Image%202026-06-27%20at%204.11.16%20PM.jpeg";

export const BitweldShowcase = () => {
  return (
    <section
      id="bitweld"
      data-testid="bitweld-section"
      className="relative bg-[#0B0E12] py-24 md:py-32 border-t border-[#F5F1EA]/8 overflow-hidden"
    >
      <div className="absolute -top-40 right-1/2 w-[500px] h-[500px] rounded-full bg-brand-red/[0.05] blur-[140px] pointer-events-none" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14 items-end">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-brand-red" />
              <span data-testid="bitweld-eyebrow" className="text-[11px] uppercase tracking-[0.35em] text-brand-red font-medium font-sans">
                Our Brand
              </span>
            </div>
            <h2
              data-testid="bitweld-heading"
              className="font-display tracking-tight text-white text-3xl md:text-4xl lg:text-5xl leading-[1.1] font-medium"
            >
              Introducing <span className="italic text-brand-red font-normal">BITWELD™</span> <br />
              Built for Strength. Made to Perform.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base text-[#A8A29A] leading-relaxed font-sans">
              BITWELD is our flagship line of premium welding hoses — engineered with high durability, burst resistance, and heat resistance for the most demanding professional welders.
            </p>
          </div>
        </div>

        {/* Feature strip */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[#F5F1EA]/8 mb-10">
          {[
            "High Durability",
            "Burst Resistant",
            "High Heat Resistance",
            "Safe & Reliable",
          ].map((f, i) => (
            <div
              key={i}
              data-testid={`bitweld-feature-${i}`}
              className="bg-[#0B0E12] p-6 flex items-center gap-3"
            >
              <span className="w-1.5 h-1.5 bg-brand-red rounded-full flex-shrink-0" />
              <span className="text-sm md:text-base text-white/85 font-sans font-medium">{f}</span>
            </div>
          ))}
        </div>

        {/* Posters grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div
            data-testid="bitweld-poster-1"
            className="group relative bg-[#161A21] border border-[#F5F1EA]/10 overflow-hidden hover:border-brand-red/40 transition-colors"
          >
            <div className="relative aspect-[3/4] overflow-hidden bg-white">
              <img
                src={BITWELD_POSTER_1}
                alt="BITWELD Welding Hose"
                className="w-full h-full object-contain group-hover:scale-[1.02] transition-transform duration-700"
              />
            </div>
            <div className="p-6 border-t border-[#F5F1EA]/10 flex items-center justify-between">
              <div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-brand-red font-sans font-medium mb-1">
                  Product Line 01
                </div>
                <h3 className="font-display italic text-2xl text-white font-medium">BITWELD Welding Hose</h3>
                <p className="text-xs text-white/50 mt-1 font-sans">Available in Blue &amp; Red • 8mm &amp; 10mm • BIS Certified (IS:447)</p>
              </div>
            </div>
          </div>

          <div
            data-testid="bitweld-poster-2"
            className="group relative bg-[#161A21] border border-[#F5F1EA]/10 overflow-hidden hover:border-brand-red/40 transition-colors"
          >
            <div className="relative aspect-[3/4] overflow-hidden bg-black">
              <img
                src={BITWELD_POSTER_2}
                alt="BITWELD Twin Welding Hose"
                className="w-full h-full object-contain group-hover:scale-[1.02] transition-transform duration-700"
              />
            </div>
            <div className="p-6 border-t border-[#F5F1EA]/10 flex items-center justify-between">
              <div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-brand-red font-sans font-medium mb-1">
                  Product Line 02
                </div>
                <h3 className="font-display italic text-2xl text-white font-medium">BITWELD Twin Welding Hose</h3>
                <p className="text-xs text-white/50 mt-1 font-sans">For Welding • Cutting • Furnace • LPG — Red / Blue / Black</p>
              </div>
            </div>
          </div>
        </div>

        {/* Tagline strip */}
        <div
          data-testid="bitweld-tagline"
          className="mt-12 bg-brand-red text-white p-8 md:p-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6"
        >
          <div className="font-display text-2xl md:text-3xl font-medium leading-tight tracking-tight">
            <span className="italic">BITWELD</span> — Strong Hose. Safer Work. <br className="hidden md:block" /> Better Results.
          </div>
          <a
            href="#contact"
            data-testid="bitweld-cta"
            className="inline-flex items-center gap-3 border-2 border-white/90 hover:bg-white hover:text-brand-red text-white px-8 py-4 uppercase tracking-[0.22em] text-[11px] font-semibold transition-colors font-sans w-fit"
          >
            Request Bitweld Quote
          </a>
        </div>
      </div>
    </section>
  );
};
